import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-rule-edit"
  }, [_c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ruleModeMetricDisableTitle'),
      "open": _vm.ruleModeMetricsDisablePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable'),
        color: _vm.color,
        emit: 'disable-metrics'
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.ruleModes.metrics = true;
        _vm.ruleModeMetricsDisablePrompt = false;
        _vm.toggleStateMetricMode();
      },
      "disable-metrics": function ($event) {
        _vm.ruleModes.metrics = false;
        _vm.ruleModeMetricsDisablePrompt = false;
        _vm.toggleStateMetricMode();
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ruleModeMetricDisableText')) + "\n  ")]), _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        _vm.$emit('cancel-edit');
        _vm.editedRule = {};
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c(VRow, {
          staticClass: "px-2",
          attrs: {
            "align": "center"
          }
        }, [_c(VCol, {
          staticClass: "py-0 my-0",
          attrs: {
            "cols": "12",
            "sm": _vm.editedRule.id ? 6 : 12,
            "md": _vm.editedRule.id ? 8 : 12
          }
        }, [_c('h3', {
          class: `my-0 headline ${_vm.color}--text`
        }, [_vm._v("\n            " + _vm._s(_vm.editedRule.properties.title) + "\n            " + _vm._s(_vm.editedRule.properties.title ? '' : _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler')[_vm.editedRule.id ? 'editRule' : 'addRule']) + "\n          ")])]), _vm.editedRule.id ? _c(VCol, {
          staticClass: "py-0 my-0 text-right",
          attrs: {
            "cols": "12",
            "sm": "6",
            "md": "4"
          }
        }, [_c('span', {
          staticClass: "text-body-2"
        }, [_c(VIcon, {
          staticClass: "mx-1 pb-1",
          attrs: {
            "color": !_vm.editedRule.properties.disabled ? _vm.color : 'danger',
            "size": "18"
          }
        }, [_vm._v("\n              fal fa-" + _vm._s(`lightbulb${_vm.editedRule.properties.disabled ? '-slash' : ''}`) + "\n            ")]), _c('span', {
          class: `${_vm.editedRule.properties.disabled ? 'danger' : _vm.color}--text`
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler')[_vm.editedRule.properties.disabled ? 'ruleIsDisabled' : 'ruleIsActive']) + "\n            ")])], 1)]) : _vm._e(), _c(VCol, {
          staticClass: "pb-0 mb-0",
          attrs: {
            "cols": "12"
          }
        }, [_c(VTextField, {
          attrs: {
            "disabled": _vm.disabled,
            "color": _vm.color,
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.title'),
            "rules": _vm.requiredRule,
            "required": "",
            "hide-details": "",
            "data-cy": "rule_title"
          },
          model: {
            value: _vm.editedRule.properties.title,
            callback: function ($$v) {
              _vm.$set(_vm.editedRule.properties, "title", $$v);
            },
            expression: "editedRule.properties.title"
          }
        })], 1)], 1)];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [!_vm.isMobile ? _c('span', [_vm.editedRule.id && !_vm.disabled ? _c(VBtn, {
          class: `v-btn-x mx-1 bg-rounded-button-${_vm.editedRule.properties.disabled ? _vm.color : 'danger'}`,
          attrs: {
            "color": _vm.editedRule.properties.disabled ? _vm.color : 'danger',
            "rounded": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.toggleRuleState();
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-" + _vm._s(`lightbulb${!_vm.editedRule.properties.disabled ? '-slash' : ''}`))]), _vm._v("\n           \n          " + _vm._s(_vm.editedRule.properties.disabled ? _vm.$i18n_t('DigitalTwin.DigitalTwin.twinEnable') : _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisable')) + "\n        ")], 1) : _vm._e(), !_vm.disabled ? _c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "disabled": !_vm.formValid,
            "color": _vm.color,
            "rounded": "",
            "text": "",
            "data-cy": "create_rule"
          },
          on: {
            "click": function ($event) {
              return _vm.saveRule();
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fas fa-save")]), _vm._v("\n           \n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler')[_vm.editedRule.id ? 'save' : 'create']) + "\n        ")], 1) : _vm._e()], 1) : _c('span', [_vm.editedRule.id && !_vm.disabled ? _c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.editedRule.properties.disabled ? _vm.color : 'danger'}`,
          attrs: {
            "color": _vm.editedRule.properties.disabled ? _vm.color : 'danger',
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.toggleRuleState();
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-" + _vm._s(`lightbulb${!_vm.editedRule.properties.disabled ? '-slash' : ''}`))])], 1) : _vm._e(), !_vm.disabled ? _c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "disabled": !_vm.formValid,
            "color": _vm.color,
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.saveRule();
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fas fa-save")])], 1) : _vm._e()], 1)];
      },
      proxy: true
    }])
  }, [_c(VForm, {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, {
    staticClass: "px-2",
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ruleMode')))])]), _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.metrics'),
      "hide-details": ""
    },
    on: {
      "change": _vm.stateMetricModeChanged
    },
    model: {
      value: _vm.ruleModes.metrics,
      callback: function ($$v) {
        _vm.$set(_vm.ruleModes, "metrics", $$v);
      },
      expression: "ruleModes.metrics"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geofencing'),
      "hide-details": ""
    },
    on: {
      "change": _vm.toggleGeofenceMode
    },
    model: {
      value: _vm.ruleModes.geofences,
      callback: function ($$v) {
        _vm.$set(_vm.ruleModes, "geofences", $$v);
      },
      expression: "ruleModes.geofences"
    }
  })], 1), _c(VSpacer), _c(VCol, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description mb-0 pb-0"
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ruleModeText')) + "\n          ")])])], 1), _vm.ruleModes.metrics && _vm.ruleModes.geofences ? _c(VExpansionPanels, {
    staticClass: "my-2",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ruleInput')) + "\n            ")])]), _c(VExpansionPanelContent, [_vm.ruleModes.metrics && _vm.ruleModes.geofences ? _c(VTabs, {
    staticClass: "px-1",
    model: {
      value: _vm.modeTab,
      callback: function ($$v) {
        _vm.modeTab = $$v;
      },
      expression: "modeTab"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-metrics"
    }
  }, [_c(VIcon, {
    staticClass: "mr-2"
  }, [_vm._v("fal fa-network-wired")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.metrics')) + "\n              ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-geofences"
    }
  }, [_c(VIcon, {
    staticClass: "mr-2"
  }, [_vm._v("fal fa-map-marker-check")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geofencing')) + "\n              ")], 1), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.modeTab,
      callback: function ($$v) {
        _vm.modeTab = $$v;
      },
      expression: "modeTab"
    }
  }, [_c(VTabItem, {
    key: "metrics",
    staticClass: "pt-3",
    attrs: {
      "value": "tab-metrics"
    }
  }, [_c('core-dtwin-rule-edit-metrics', {
    ref: "metrics",
    staticClass: "mx-2",
    attrs: {
      "disabled": _vm.disabled,
      "rule": _vm.editedRule,
      "states": _vm.statesCopy,
      "templateContext": _vm.isTemplateContext
    },
    on: {
      "add-state": index => _vm.editRuleAddState(index),
      "delete-state": index => _vm.editRuleDeleteState(index),
      "state-selected": metric => _vm.didSelectState(metric),
      "validate-form": function ($event) {
        return _vm.validateForm();
      },
      "open-state": stateId => _vm.$emit('open-state', stateId)
    }
  })], 1), _c(VTabItem, {
    key: "geofences",
    staticClass: "pt-3",
    attrs: {
      "value": "tab-geofences"
    }
  }, [_c('core-dtwin-rule-edit-geo-fences', {
    ref: "geofences",
    staticClass: "mx-2",
    attrs: {
      "disabled": _vm.disabled,
      "rule": _vm.editedRule
    },
    on: {
      "refresh-form": function ($event) {
        return _vm.refreshForm();
      },
      "add-geo-fence": index => _vm.editRuleAddGeoFence(index),
      "delete-geo-fence": index => _vm.editRuleDeleteGeoFence(index)
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1) : [_vm.ruleModes.metrics ? _c(VExpansionPanels, {
    staticClass: "my-4",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.metrics')) + "\n              ")])]), _c(VExpansionPanelContent, [_c('core-dtwin-rule-edit-metrics', {
    ref: "metrics",
    staticClass: "mx-2",
    attrs: {
      "disabled": _vm.disabled,
      "rule": _vm.editedRule,
      "states": _vm.statesCopy,
      "templateContext": _vm.isTemplateContext && !_vm.isCreatedByTemplate
    },
    on: {
      "add-state": index => _vm.editRuleAddState(index),
      "delete-state": index => _vm.editRuleDeleteState(index),
      "state-selected": metric => _vm.didSelectState(metric),
      "validate-form": function ($event) {
        return _vm.validateForm();
      },
      "open-state": stateId => _vm.$emit('open-state', stateId)
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.ruleModes.geofences ? _c(VExpansionPanels, {
    staticClass: "my-4",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geofencing')) + "\n              ")])]), _c(VExpansionPanelContent, [_c('core-dtwin-rule-edit-geo-fences', {
    ref: "geofences",
    staticClass: "mx-2",
    attrs: {
      "disabled": _vm.disabled,
      "rule": _vm.editedRule
    },
    on: {
      "refresh-form": function ($event) {
        return _vm.refreshForm();
      },
      "add-geo-fence": index => _vm.editRuleAddGeoFence(index),
      "delete-geo-fence": index => _vm.editRuleDeleteGeoFence(index)
    }
  })], 1)], 1)], 1) : _vm._e()], _c(VExpansionPanels, {
    staticClass: "my-6",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditions')) + "\n            ")])]), _c(VExpansionPanelContent, [_c(VRow, {
    staticClass: "px-1",
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "py-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c(VCheckbox, {
    staticClass: "mt-0",
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.throttle'),
      "hide-details": ""
    },
    model: {
      value: _vm.editedRule.properties.throttle,
      callback: function ($$v) {
        _vm.$set(_vm.editedRule.properties, "throttle", $$v);
      },
      expression: "editedRule.properties.throttle"
    }
  })], 1), _c(VCol, {
    staticClass: "py-1",
    attrs: {
      "cols": "auto"
    }
  }, [_c(VTextField, {
    class: _vm.editedRule.properties.throttle ? 'required' : '',
    style: _vm.editedRule.properties.throttle ? '' : 'opacity: 0.6',
    attrs: {
      "disabled": !_vm.editedRule.properties.throttle || _vm.disabled,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.throttleHours'),
      "rules": _vm.editedRule.properties.throttle ? _vm.throttleRules : [],
      "hide-details": "auto"
    },
    on: {
      "input": e => {
        _vm.editedRule.properties.throttleHours = parseFloat(e) || undefined;
      }
    },
    model: {
      value: _vm.editedRule.properties.throttleHours,
      callback: function ($$v) {
        _vm.$set(_vm.editedRule.properties, "throttleHours", $$v);
      },
      expression: "editedRule.properties.throttleHours"
    }
  })], 1), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.throttleText'))
    }
  })])], 1), _c(VDivider, {
    staticClass: "mb-3"
  }), _vm.ruleModes.metrics ? _c('core-dtwin-rule-edit-conditions-wrapper', {
    attrs: {
      "rule": _vm.editedRule,
      "disabled": _vm.disabled,
      "states": _vm.statesCopy,
      "templateContext": _vm.isTemplateContext,
      "isCreatedByTemplate": _vm.isCreatedByTemplate
    }
  }) : _c('core-dtwin-rule-edit-conditions-no-metrics', {
    attrs: {
      "rule": _vm.editedRule,
      "disabled": _vm.disabled,
      "states": _vm.statesCopy
    },
    on: {
      "refresh-form": function ($event) {
        return _vm.refreshForm();
      },
      "update:rule": $event => _vm.refreshForm($event)
    }
  })], 1)], 1)], 1), !_vm.editedRule.properties.timeTriggerOnly ? _c(VExpansionPanels, {
    staticClass: "my-6",
    attrs: {
      "value": _vm.executionTimes.length ? 0 : null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.executionTimes.headline')) + "\n            ")])]), _c(VExpansionPanelContent, [_c('core-dtwin-rule-edit-execution-times', {
    attrs: {
      "rule": _vm.editedRule,
      "disabled": _vm.disabled
    },
    on: {
      "refresh-form": function ($event) {
        return _vm.refreshForm();
      },
      "add-execution-time": index => _vm.editRuleAddExecutionTime(index),
      "delete-execution-time": index => _vm.editRuleDeleteExecutionTime(index)
    }
  })], 1)], 1)], 1) : _vm._e(), _c(VExpansionPanels, {
    staticClass: "my-6",
    attrs: {
      "value": _vm.timeTriggers.length ? 0 : null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.headline')) + "\n            ")])]), _c(VExpansionPanelContent, [_c('core-dtwin-rule-edit-time-triggers', {
    attrs: {
      "rule": _vm.editedRule,
      "disabled": _vm.disabled,
      "states": _vm.statesCopy
    },
    on: {
      "refresh-form": function ($event) {
        return _vm.refreshForm();
      },
      "add-time-trigger": index => _vm.editRuleAddTimeTrigger(index),
      "delete-time-trigger": index => _vm.editRuleDeleteTimeTrigger(index)
    }
  })], 1)], 1)], 1), (_vm.editedRule.properties.triggeredAggregates || []).length === 0 && (_vm.editedRule.properties.actions || []).length === 0 ? [_c('div', {
    staticClass: "mx-2 my-0 py-0 error--text text-bold"
  }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commandOrAggtriggerRequired')) + "\n        ")]), _c(VInput, {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "value": false,
      "rules": [v => v === true]
    }
  })] : _vm._e(), _c(VExpansionPanels, {
    staticClass: "mt-6 mb-4",
    attrs: {
      "value": (_vm.editedRule.properties.actions || []).length > 0 || !_vm.editedRule.id ? 0 : null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.commands')) + "\n            ")])]), _c(VExpansionPanelContent, [_c('core-dtwin-rule-edit-commands', {
    staticClass: "mx-2",
    attrs: {
      "formValid": _vm.formValid,
      "disabled": _vm.disabled,
      "hasTwinEditPermission": _vm.hasTwinEditPermission,
      "rule": _vm.editedRule,
      "states": _vm.states,
      "dtwin": _vm.dtwin,
      "template": _vm.template
    },
    on: {
      "add-action": index => _vm.editedRule.properties.actions.splice(index, 0, {
        params: {}
      }),
      "delete-action": index => _vm.editRuleDeleteAction(index),
      "command-changed": commandIndex => _vm.handleCommandChanged(commandIndex)
    }
  })], 1)], 1)], 1), _vm.aggregateStates.length ? _c(VExpansionPanels, {
    staticClass: "mt-6 mb-4",
    attrs: {
      "value": (_vm.editedRule.properties.triggeredAggregates || []).length > 0 ? 0 : null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.aggregateTrigger.title')) + "\n            ")])]), _c(VExpansionPanelContent, [_c('core-dtwin-rule-edit-aggregate-triggers', {
    staticClass: "mx-2",
    attrs: {
      "disabled": _vm.disabled,
      "hasTwinEditPermission": _vm.hasTwinEditPermission,
      "rule": _vm.editedRule,
      "states": _vm.aggregateStates,
      "tenantId": _vm.isTemplateContext ? _vm.template.tenantId : _vm.dtwin.tenantId
    },
    on: {
      "add-aggregate": _vm.editRuleAddAggregate,
      "delete-aggregate": _vm.editRuleDeleteAggregate
    }
  })], 1)], 1)], 1) : _vm._e(), _c(VExpansionPanels, {
    staticClass: "my-6",
    attrs: {
      "value": 0
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ruleTester')) + "\n            ")])]), _c(VExpansionPanelContent, [_c('p', {
    staticClass: "text-body-2 mx-2 card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.ruleTesterDescription'))
    }
  }), _c(VRow, {
    staticClass: "mx-0 px-0"
  }, _vm._l(_vm.editedRule.properties.stateMetrics, function (stateMetric, i) {
    return _c(VCol, {
      key: `statemetric_test_${i}`,
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4"
      }
    }, [_c(VTextField, {
      attrs: {
        "disabled": _vm.disabled,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": stateMetric.key,
        "required": "",
        "hide-details": "auto"
      },
      model: {
        value: _vm.testStateMetrics[stateMetric.key],
        callback: function ($$v) {
          _vm.$set(_vm.testStateMetrics, stateMetric.key, $$v);
        },
        expression: "testStateMetrics[stateMetric.key]"
      }
    })], 1);
  }), 1), _c(VRow, {
    staticClass: "mx-0 px-0"
  }, [!_vm.isMobile ? _c('span', [_c(VBtn, {
    class: 'v-btn-x px-4 mx-2 v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "disabled": !_vm.formValid,
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.testRule();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-microscope")]), _vm._v("\n                   \n                  " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.testRule')) + "\n                ")], 1)], 1) : _c('span', [_c(VBtn, {
    class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "disabled": !_vm.formValid,
      "color": _vm.color,
      "icon": "",
      "info": "",
      "fab": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.testRule();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-microscope")])], 1)], 1)]), _vm.testResults && _vm.testResults['javascriptError'] ? _c(VRow, {
    staticClass: "mt-4 mx-0 px-0"
  }, [_c(VIcon, {
    staticClass: "ml-4 mr-0",
    attrs: {
      "color": "danger",
      "size": "16"
    }
  }, [_vm._v("fal fa-exclamation-triangle")]), _c('pre', {
    staticClass: "danger--text ml-2"
  }, [_vm._v(_vm._s(_vm.testResults.javascriptError))])], 1) : _vm.testResults && _vm.testResults['ruleMetrics'] ? _c(VRow, {
    staticClass: "mt-2 mx-0 px-0"
  }, [_vm._l(Object.keys(_vm.testResults['ruleMetrics']), function (metricKey, i) {
    return _c(VCol, {
      key: `statemetric_test_result_${i}`,
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4"
      }
    }, [_c(VTextField, {
      attrs: {
        "value": _vm.testResults['ruleMetrics'][metricKey],
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": metricKey,
        "readonly": true,
        "disabled": true,
        "hide-details": "auto",
        "required": ""
      }
    })], 1);
  }), _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.conditions')) + ":")]), _c('pre', [_vm._v(_vm._s(_vm.testResults['conditionResult']))])])], 2) : _vm._e()], 1)], 1)], 1)], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };